import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { DownIcons } from "../Icons/Icons";

import styles from "./SelectBox.module.css";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const SelectBox = ({
  label,
  onChange,
  children,
  className,
  type = "normal",
  title,
  style,
  select,
  required,
  values,
  disabled = true,
  noEllipsis,
}) => {
  const { t } = useTranslation()
  const [value, setValue] = useState(t("location.all"));
  const [isShow, setIsShow] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const refSelect = useRef(null)

  const handleClick = () => {
    if (disabled) {
      setIsShow(!isShow);
    }
  };
  const handleOnChangeData = (value, label) => {
    setValue(label);
    if (onChange) {
      onChange(value, label);
    }
    setIsShow(!isShow);
    setIsChange(true);
  };
  useEffect(() => {
    if (select) {
      setValue("Lựa chọn");
    }
    if (values) {
      setValue(values);
    }
  }, [values, select]);

  useEffect(() => {
    const clickOutSide = (e) => {
      if (e.target !== refSelect.current) {
        setIsShow(false)
      }
    }
    document.addEventListener('click', clickOutSide);
    return () => document.removeEventListener('click', clickOutSide);
  }, [])

  return (
    <div className={cx("select-box", className)} style={{ ...style }}>
      {title && (
        <span
          className={cx(
            "title",
            required && value === "Lựa chọn" ? "title-error" : ""
          )}
        >
          {title}
        </span>
      )}
      <div
        className={cx(
          "select",
          type,
          isChange && required && value === "Lựa chọn" ? "error" : ""
        )}
      >
        <div
          className={cx(
            "input-select",
            type === "normal" ? "input-normal" : ""
          )}
        >
          <div className={cx("input")}>
            {label && <div className={cx("label")}>{label}</div>}
            <div className={cx("value", noEllipsis && "no-ellipsis")}>{value}</div>
          </div>
          <div className={cx("icon")}>
            <DownIcons />
          </div>
        </div>
        {isShow && (
          <div
            className={cx("data", type === "small" ? "ps-small" : "ps-normal")}
          >
            {React.Children.map(children, (child, i) => {
              return React.cloneElement(child, {
                index: i + 1,
                onChange: handleOnChangeData,
                size: type,
              });
            })}
          </div>
        )}
        <div className={cx('top-box')} ref={refSelect} onClick={handleClick}></div>
      </div>
      {value !== "Lựa chọn" ? (
        ""
      ) : required && isChange ? (
        <span className={cx("span-error")}>Vui lòng chọn trường này</span>
      ) : (
        ""
      )}
    </div>
  );
};

export default SelectBox;
